import { Image } from "@chakra-ui/react";
import { Flex } from "@chakra-ui/layout";
import { Skeleton, Text } from "@chakra-ui/react";
import { PastaItem } from "core/features/documentos/typings";
import colors from "core/resources/theme/colors";
import moment from "moment";
import KebabMenu from "../KebabMenu";
import iconePasta from "assets/images/svgs/icone-pasta.svg";
import { TipoDestinoEnum } from "core/features/documentos/enums";

interface PastaProps {
  pasta: Partial<PastaItem> | undefined;
  isLoading: boolean;
  selected: boolean;
  onDelete?: (id: string) => any;
  onEdit?: (
    id: string,
    name: string,
    destinoId: string,
    tipoDestinoId: TipoDestinoEnum | null
  ) => any;
  hasPermissionEdit?: boolean;
  hasPermissionDelete?: boolean;
}

function Pasta({
  pasta,
  isLoading,
  selected,
  onEdit,
  onDelete,
  hasPermissionDelete,
  hasPermissionEdit,
}: PastaProps) {
  return (
    <Flex
      bg={colors.white}
      rounded={16}
      p={4}
      borderWidth={1}
      borderColor={selected && !isLoading ? colors.primary : colors.white}
      h="90px"
      alignItems="center"
    >
      {!isLoading ? (
        <>
          <Flex w="55px" h="55px" mr={2} alignItems="center">
            <Image w="100%" src={iconePasta} />
          </Flex>
          <Flex flexDir="column" justifyContent="center" w="100%">
            <Flex justifyContent="space-between">
              <Text fontSize={14} fontWeight="medium" noOfLines={1}>
                {pasta?.nome || "Pasta"}
              </Text>
              {pasta?.id ? (
                <KebabMenu
                  onEdit={
                    hasPermissionEdit
                      ? () =>
                          onEdit?.(
                            pasta.id!,
                            pasta?.nome!,
                            pasta?.destinoId!,
                            pasta?.tipoDestinoId!
                          )
                      : undefined
                  }
                  onDelete={
                    hasPermissionDelete
                      ? () => onDelete?.(pasta.id!)
                      : undefined
                  }
                />
              ) : null}
            </Flex>
            {pasta?.updatedAt ? (
              <Text fontSize={12} fontWeight="light" color={colors.black900}>
                Ult. atualização: {moment(pasta.updatedAt).format("DD/MM/YYYY")}
              </Text>
            ) : null}
          </Flex>
        </>
      ) : (
        <Skeleton w="100%" h="100%" />
      )}
    </Flex>
  );
}

export default Pasta;
